import { useState } from "react";
import dayjs from "dayjs";
import { pesquisarCompatibilidadesService } from "../../../services/pesquisarCompatibilidadesService";
import { numberPadrao } from "../../../uteis/formatPhoneNumber";
import {
  Agrupado,
  Compatibilidade,
  montarCompatibilidadesAgrupadas,
} from "../utils/compatibilidades";

const getTipoInteresse = (alugar?: boolean, trocar?: boolean) => {
  if (alugar && trocar) return "ALUGAR_TROCAR";
  if (alugar) return "ALUGAR";
  if (trocar) return "TROCAR";
  return "";
};

export const usePesquisa = () => {
  const [resultadoPesquisa, setResultadoPesquisa] = useState<Agrupado[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const realizarPesquisa = async (pesquisaData: any) => {
    setIsLoading(true);
    setError(null);

    try {
      const payload = {
        empreendId: pesquisaData.empreendId,
        dataInicio: dayjs(pesquisaData.dataInicio).format("YYYY-MM-DD"),
        dataFim: dayjs(pesquisaData.dataFim).format("YYYY-MM-DD"),
        nome: pesquisaData.nome?.trim() || "",
        celular: numberPadrao(pesquisaData.celular),
        tipoInteresse: getTipoInteresse(
          pesquisaData.alugar,
          pesquisaData.trocar
        ),
      };

      const data = await pesquisarCompatibilidadesService(payload);
      const compatibilidades = Array.isArray(data?.compatibilidades)
        ? data.compatibilidades
        : [];

      const agrupado = await montarCompatibilidadesAgrupadas(
        compatibilidades as Compatibilidade[]
      );

      setResultadoPesquisa(agrupado);
      setSuccess(
        data?.mensagem ||
          (compatibilidades.length > 0
            ? "Pesquisa realizada com sucesso!"
            : "Nenhuma compatibilidade encontrada para os filtros informados.")
      );
    } catch (error) {
      setError(`Erro ao realizar pesquisa: ${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    realizarPesquisa,
    resultadoPesquisa,
    isLoading,
    resetError,
    resetSuccess,
    success,
    error,
  };
};
